import { useEffect, useRef, useState } from "react";

export type AutoFilterState = { tags: string[], search: string };

export function useAutoFilter<T extends { id: string, title?: string }>(data: T[] | undefined) {
    const dataRef = useRef(data);
    dataRef.current = data;

    const filterState = useRef<AutoFilterState>({ tags: [], search: "" });
    const [filteredData, setFilteredData] = useState<T[]>([]);

    function applyFilter() {
        const items = dataRef.current ?? [];
        const { tags, search } = filterState.current;
        const query = search.trim().toLowerCase();

        if (tags.length > 0 || query) {
            setFilteredData(items.filter(r => {
                const tagMatch = tags.every(t => r.id.indexOf(t) >= 0);
                const textMatch = !query ||
                    r.id.toLowerCase().includes(query) ||
                    (r.title ?? "").toLowerCase().includes(query);
                return tagMatch && textMatch;
            }));
        } else {
            setFilteredData([...items]);
        }
    }

    useEffect(() => {
        applyFilter();
    }, [data]);

    return {
        filteredData,
        onFilterChange: (f: AutoFilterState) => {
            filterState.current = f;
            applyFilter();
        },
    };
}
